// ============================================================
// BOOTH — what a report can say.
//
// Shared because two sides have to agree on it: the sheet a person fills in
// and the route that files it. It lived in the messages page, which meant the
// server had no idea what a valid reason was.
//
// No env and no imports on purpose — this file is read by the browser.
// ============================================================

/** Offered as the reason on a report. Free text goes in the details field
 *  underneath; these exist so a moderator can sort a queue, and so the
 *  reporter is not made to describe harassment in a box before anything
 *  happens. */
export const REPORT_REASONS = [
  "Harassment or threats",
  "Spam or scam",
  "Impersonation",
  "Off-platform payment request",
  "Something else",
] as const

export type ReportReason = (typeof REPORT_REASONS)[number]

/** What was reported. `user` is all the messages sheet sends; a profile or a
 *  listing is the same table and the same route with a different type — see
 *  scripts/1033-blocks-and-reports.sql. */
export const REPORT_TYPES = ["user", "listing", "message"] as const

export type ReportType = (typeof REPORT_TYPES)[number]

export const MAX_REPORT_DETAILS = 2000
